import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const service: AppRouteModule = {
  path: '/service',
  name: 'Service',
  component: LAYOUT,
  redirect: '',
  meta: {
    icon: 'icon-a-gongdanguanli2',
    title: '工单管理',
  },
  children: [
    {
      path: '/service/work',
      name: 'ServiceList',
      component: () => import('/@/views/service/work.vue'),
      meta: {
        // affix: true,
        title: '我的工单',
        code: 'B010101',
        noKeepAlive: true,
        // 这里不判断权限，赵烊说一定会有这个权限的，所以删除home页，直接到这来
      },
    },
    {
      path: '/service/detail',
      name: 'ServiceDetail',
      component: () => import('/@/views/service/detail.vue'),
      meta: {
        // affix: true,
        title: '详情',
        code: '',
        hideMenu: true,
        belong: '/service/work',
        noKeepAlive: true,
      },
    },
    {
      path: '/service/false',
      name: 'ServiceFalse',
      component: () => import('/@/views/service/false/index.vue'),
      meta: {
        title: '错误工单',
        code: 'B010201',
      },
    },
    {
      path: '/service/false/detail',
      name: 'ServiceFalseDetail',
      component: () => import('/@/views/service/false/detail.vue'),
      meta: {
        title: '识别详情',
        code: '',
        belong: '/service/false',
        noKeepAlive: true,
        hideMenu: true,
      },
    },
    {
      path: '/service/all',
      name: 'ServiceAll',
      component: () => import('/@/views/service/all/index.vue'),
      meta: {
        title: '全部工单',
        code: 'B010301',
      },
    },
    {
      path: '/service/all/detail',
      name: 'ServiceAllDetail',
      component: () => import('/@/views/service/all/detail.vue'),
      meta: {
        title: '工单详情',
        code: '',
        belong: '/service/all',
        noKeepAlive: true,
        hideMenu: true,
      },
    },
  ],
};

export default service;
